import get from 'lodash/get';

export default content => ({
  countryCode: get(content, 'zone.code', '')
});
